import React, { Component } from 'react';
import * as yup from 'yup';
import { message } from 'antd';
import RightSlider from '../../Common/RightSlider';
import dclogo from "../../../../Assets/images/doodycalls.png";
import {errorHandle} from "../../../Common/errorHandle";


class Register extends Component {
  state = {
    user: {
      "first_name": "",
      "last_name": "",
      "email": "",
      "password1": "",
      "password2": "",
      "role": ["admin"]
    },

    validPassword: {
      containsUppercase: false,
      containsNumber: false,
      checkLength: false,
      is_password_match: false,
    },
    is_btn_active: false,
    loader: false,
    is_password1_toggle: false,
    is_password2_toggle: false
  }

  componentDidMount = () => {
    const accessToken = JSON.parse(localStorage.getItem("authUser"))
      ? JSON.parse(localStorage.getItem("authUser")).key
      : "";
    if (accessToken) {
      this.props.history.push('/dashboard')
    }
    else {
      let uid = '';
      let token = this.props.match.params.token;


      if (this.props.location.search.split('=')[1]) {
        uid = this.props.location.search.split('=')[1]
      }
      let data = {
        uid,
        token
      }
      this.props.verifyRegisterUser(data);
      this.setState({
        loader: true
      })
    }
  }



  UNSAFE_componentWillReceiveProps = (props) => {
    // message.destroy();
    // Register User Response
    if (Object.keys(props.Register.data).length > 0 && props.Register.data !== this.props.Register.data) {
      // display Success messsage

      message.success('Register Successfully');
      setTimeout(() => {
        this.props.history.push('/')
      }, 1500);

    }
    if (Object.keys(props.Register.errors).length > 0 && props.Register.errors !== this.props.Register.errors) {
      // display error messsage
      this.setState({ loader: false })
      if (props.Register.errors.email) {
        message.error(props.Register.errors.email);
      }
      else if (props.Register.errors.username) {
        message.error(props.Register.errors.username);
      }
      else {
        errorHandle(props.Register.errors)
      }
    }



    if (Object.keys(props.VerifyRegister.data).length > 0 && props.VerifyRegister.data !== this.props.VerifyRegister.data) {
      // display Success messsage
      let { user } = this.state;
      let { first_name, last_name, email, uuid } = props.VerifyRegister.data;

      user = Object.assign(user, {
        first_name,
        last_name,
        email,
        uuid
      })


      this.setState({
        loader: false,
        user
      })
    }
    if (Object.keys(props.VerifyRegister.errors).length > 0 && props.VerifyRegister.errors !== this.props.VerifyRegister.errors) {
      this.setState({
        loader: false
      })
      message.error('Something went wrong');
    }


    setTimeout(() => {
      // message.destroy();
    }, 10000);
  }


  // set form value
  onUserFormChange = (e) => {
    let { user, validPassword } = this.state;

    user = Object.assign(user, { [e.target.name]: e.target.value });


    //Password validation
    if (e.target.name === 'password1') {
      validPassword = Object.assign(validPassword, {
        'containsUppercase': (/[A-Z]/).test(e.target.value),
        'containsNumber': (/\d/).test(e.target.value),
        'checkLength': e.target.value.length >= 8,
        'is_password_match': user.password1 && user.password1 === user.password2
      });
    }
    if (e.target.name === 'password2') {
      validPassword = Object.assign(validPassword, {
        'is_password_match': user.password1 && user.password1 === user.password2
      });
    }
    this.setState({ user, validPassword });
    this.validateUser(user, validPassword);
  }

  // Validate Form
  validateUser = (user, validPassword) => {

    const UserSchema = yup.object().shape({
      user: yup.object().shape(
        {
          first_name: yup.string().required("First name is required"),
          last_name: yup.string().required("Last name is required"),
          email: yup.string().required("Email is required").email('Your Email is invalid.'),
          password1: yup.string().required("Password is required"),
          password2: yup.string()
            .oneOf([yup.ref('password1'), null])
            .required('Password confirm is required'),
        }
      ),
      validPassword: yup.object().shape({
        containsUppercase: yup.bool().oneOf([true], ''),
        containsNumber: yup.bool().oneOf([true], ''),
        is_btn_active: yup.bool().oneOf([true], ''),
        is_password_match: yup.bool().oneOf([true], ''),

      })
    })

    const UserData = {
      user,
      validPassword
    }
    // check validity
    let IsValid;

    UserSchema.isValid(UserData)
      .then(function (valid) {
        IsValid = valid
      });
    var self = this;
    setTimeout(() => {
      if (IsValid) {
        self.setState({
          is_btn_active: true
        })
      }
      else {
        UserSchema.validate(UserData, { abortEarly: false })
          .catch(function () {
            self.setState({
              is_btn_active: false
            })
          });
      }
    }, 100);
  }
  //Register User
  registerUSer = (e) => {
    e.preventDefault();
    this.setState({
      loader: true
    })
    let { user } = this.state;
    let data = {
      "new_password1": user.password1,
      "new_password2": user.password2,
      "first_name": user.first_name,
      "last_name": user.last_name
    }
    this.props.userRegister(data, user.uuid)
  }

  render() {
    let { user, is_btn_active, validPassword, loader, is_password1_toggle, is_password2_toggle } = this.state;
    return (
      <div id="wrapper">
        <div className="auth-page">
          <div className="authform">
            <div className="auth-container">
              <img src={dclogo} alt="" className="logo" />
              <h1>Welcome to DoodyCalls CRM. <br />Sign up to get started.</h1>
              <label className="mb-30">Enter your details to proceed</label>
              <form onSubmit={(e) => { this.registerUSer(e); }} className="form-group">
                <div className="fitem">
                  <label>First Name</label>
                  <input type="text"
                    className="form-control"
                    placeholder="First Name"
                    name="first_name"
                    value={user.first_name}
                    onChange={(e) => { this.onUserFormChange(e) }} />
                </div>
                <div className="fitem">
                  <label>Last Name</label>
                  <input type="text"
                    className="form-control"
                    placeholder="Last Name"
                    name="last_name"
                    value={user.last_name}
                    onChange={(e) => { this.onUserFormChange(e) }} />
                </div>
                <div className="fitem">
                  <label>Email Address</label>
                  <input type="email"
                    className="disabled"
                    placeholder="Email Address"
                    name="email"
                    value={user.email}
                    disabled
                  // onChange={(e) => { this.onUserFormChange(e) }} 
                  />
                </div>
                <div className="fitem fitem-rinner">
                  <label>Password</label>
                  <input
                    type={is_password1_toggle ? 'text' : 'password'}
                    className="form-control"
                    placeholder="Start typing…"
                    name="password1"
                    value={user.password1}
                    onChange={(e) => { this.onUserFormChange(e) }} />
                  <span className="fitem-ricon">
                    <i
                      className={is_password1_toggle ? 'lar la-eye' : 'las la-low-vision'}
                      onClick={() => {
                        this.setState({ is_password1_toggle: !this.state.is_password1_toggle })
                      }}
                    ></i>
                  </span>
                </div>
                <div className="fitem fitem-rinner">
                  <label>Repeat Password</label>
                  <input
                    type={is_password2_toggle ? 'text' : 'password'}

                    className="form-control"
                    placeholder="Start typing…"
                    name="password2"
                    value={user.password2}
                    onChange={(e) => { this.onUserFormChange(e) }} />
                  <span className="fitem-ricon">

                    <i className={is_password2_toggle ? 'lar la-eye' : 'las la-low-vision'}
                      onClick={() => { this.setState({ is_password2_toggle: !this.state.is_password2_toggle }) }}
                    ></i>

                  </span>
                </div>

                <div className="fitem validate">
                  <span className={validPassword.checkLength ? 'circle success_bg' : 'circle'}></span>At leasts 8 characters<br />
                  <span className={validPassword.containsUppercase ? 'circle success_bg' : 'circle'}></span>At least one capital letter<br />
                  <span className={validPassword.containsNumber ? 'circle success_bg' : 'circle'}></span>At least one number<br />
                  <span className={validPassword.is_password_match ? 'circle success_bg' : 'circle'}></span>Passwords match<br />
                </div>

                <div className="text-right"> <button
                  type="submit"
                  className={!is_btn_active ? 'disable btn btn-secondary' : 'btn btn-secondary'}
                  disabled={!is_btn_active}>Sign Up</button>
                </div>
              </form>
            </div>
          </div>
          <RightSlider />
          {
            loader ?
              <div className='loader_wrapper'>
                <div className='loader07'></div>
              </div>
              : ''
          }
        </div>
      </div>


    );
  }
}

export default Register;